/**
 * The scrolling middle of a Dialog, Drawer or BottomSheet. The panel is capped
 * to its overlay and is a flex column, so the title and footer stay put while
 * only this body scrolls: a tall form never pushes its Save button off screen.
 * `min-h-0` lets it shrink below its content; `-m-1 p-1` keeps the 2px focus
 * ring (offset 2px) of a field at the body's edge inside the scroll box instead
 * of clipped by it. The gap matches the dialog's own, since each child used to
 * be spaced as a flex item of the dialog itself.
 */
export const overlayBodyClass = 'flex flex-col gap-4 min-h-0 overflow-y-auto -m-1 p-1';
